<template>
	<div
		:class="['rules-list-container']"
		>
		<app-table
			class="mt-5 is-not-selectable"
			name="rules"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="is-not-selectable col1">
					{{ props.row.code }}
				</td>
				<td v-show="showRow(columns, 2)" class="is-not-selectable col1">
					{{ props.row.description }}
				</td>
				<td v-show="showRow(columns, 3)" class="col2">
					{{ props.row.accountingAccount }}
				</td>
				<td v-show="showRow(columns, 4)" class="col3">
					<app-tooltip-button
						color="success"
						icon="edit"
						text="Editar"
						@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
					/>
					<app-tooltip-button
						color="error"
						icon="delete"
						text="Eliminar"
						@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
			{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
			{ id: 3, name: 'Cuenta Contable', value: 'name', checked: true, visible: true },
			{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
	};
}

export default {
	name: 'rules-list',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		currentPage: {
			default: 1,
			type: Number,
		},
		lastPage: {
			type: Number,
			default: 1,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.rules-list-container {
		padding: 0 48px;

		@media (max-width: 768px) {
			padding: 0 8px;
		}
	}

	.col1 {
		grid-column: 1 / 2;
		grid-row: 1;
		line-height: 32px;
	}

	.col2 {
		grid-column: 1 / 3;
		grid-row: 2;
		line-height: 32px;

		@media (max-width: 768px) {
			background-color: color(grey-background);
		}
	}

	.col3 {
		display: flex;
		grid-column: 2 / 3;
		grid-row: 1;
		height: 32px !important;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/rules/rules-list.vue